/**
 * Created by Gaplo917 on 8/7/2017.
 */
import * as PIXI from "pixi.js"
import "pixi-display"
import "pixi-spine"
import * as GameUtils from "./GameUtils";
import * as _ from "lodash";
const Matter = require("matter-js")
import R from "./config/R"
import * as Events from "./Events"

import { fontSpy } from './plugins/fontSpy'

const WIDTH = R.dimen.width
const HEIGHT = R.dimen.height
/**
 * app: PIXI.Application
 * engine: Matter.Engine
 * runner: Matter.Runner
 */
export default class BaseGame {
  constructor() {
    const isAntiAlias = (GameUtils.getQueryVariable('aa') || "").startsWith("1")
    const quality = Math.min(parseInt(GameUtils.getQueryVariable('q') || 5), 10)
    const isGPU = (GameUtils.getQueryVariable('gpu') || "1").startsWith("1")
    console.log(`using antialias = ${isAntiAlias} and quality = ${quality}`)
    // Rendering Part
    const app = new PIXI.Application({
      width: WIDTH,
      height: HEIGHT,
      transparent: true,
      antialias: isAntiAlias,
      sharedTicker : true,
      resolution: quality / 20 + 0.5 /* 0.5 is base quality (1024 * 768)*/,
      forceFXAA: quality === 1 ? false : isAntiAlias,
      forceCanvas: !isGPU,
      legacy: true,
      backgroundColor: 0x000001
    })
    app.view.id = "game-canvas"
    app.ticker.minFPS = 60
    if (!(app.renderer instanceof PIXI.WebGLRenderer) && isGPU){
      alert("瀏灠器過舊並不支援 WebGL，有可能出現相容性問題！\n此遊戲只支援:\nIE 11\nEdge 14+\nFirefox 24+\nChrome 33+\nSafari 8+\nOpera 47\niOS 8.0+\nAndroid 5.0+(內核更新至 Chromium 56+)\nChrome for Android 61+")
    }
    // show events log when in dev mode
    if(process.env.NODE_ENV === 'development'){

      for(let event in Events){
        const eventName = Events[event]
        console.log("dev add event logging", eventName)
        Events.hub.getEventStream(eventName).subscribe((e) => {
          console.log(eventName, e)
        })
      }
    }

    // assign to properties
    this.app = app
  }

  enableMatterPhysicEngine(){
    // Physics Engine Part
    const runner = Matter.Runner.create()
    const engine = Matter.Engine.create()

    const render = Matter.Render.create({
      element: document.body,
      engine: engine,
      options:{
        width: WIDTH,
        height: HEIGHT,
      }

    })

    // only render physic engine in dev mode
    if(process.env.NODE_ENV === 'development'){
      //Matter.Render.run(render)
      //app.stage.alpha = 0.5
    }

    this.engine = engine
    this.runner = runner
  }

  isMatterEngineEnabled(){
    return this.runner && this.engine
  }

  loadResource({ onProgress, onCompleted }){
    return this.loadQuestionJson().then((questions) => {
      // dynamic inject to R.question
      R.question = questions

      const fontsP = this.loadFonts()
      const imagesP = this.loadImages()
      const vos = _.flatMapDeep(_.values(questions).map(level => level.map(lv => lv.vo)))

      const soundsP = this.loadSounds(vos)

      const totalResCount = GameUtils.isIE11()
        ? (Object.keys(R.sounds).length + Object.keys(R.images).length)
        : (Object.keys(R.sounds).length + Object.keys(R.images).length + vos.length)


      let count = 0
      Events.hub.getEventStream(Events.LOADED_FILE).subscribe((loaded) => {
        count += parseInt(loaded)
        const percent = count / totalResCount * 100
        onProgress(percent >= 100 ? 100 : percent)
      })

      Promise.all([fontsP,soundsP,imagesP]).then(values => {
        console.log("finish all loading")
        const [a, b, resources] = values

        onCompleted(resources)
      })

    })
  }

  loadQuestionJson() {
    return new Promise((resolve, reject) => {
      const queue = new createjs.LoadQueue()
      queue.on("fileload", (event) => {
        resolve(event.result)
      })
      queue.loadFile({id: "question.json", src: 'static/config/question.json'})
      queue.load()
    })
  }

  loadFonts(){
    const p1 = new Promise((resolve, reject) => {

      fontSpy(R.textStyles.chinese(0).fontFamily, {
        glyphs: '你',
        success: function() {
          console.log(`${R.textStyles.chinese(0).fontFamily}  loaded successfully`)
          resolve()
        },
        failure: function() {
          console.warn(`${R.textStyles.chinese(0).fontFamily}字體加載失敗`);
          resolve()
        }
      })

    })

    const p2 = new Promise((resolve, reject) => {

      fontSpy(R.textStyles.pinyin(0).fontFamily, {
        glyphs: '^',
        success: function() {
          console.log(`${R.textStyles.pinyin(0).fontFamily}  loaded successfully`)
          resolve()
        },
        failure: function() {
          console.warn(`${R.textStyles.pinyin(0).fontFamily}字體加載失敗`);
          resolve()
        }
      })

    })

    const p3 = new Promise((resolve, reject) => {

      fontSpy(R.textStyles.timer(0).fontFamily, {
        glyphs: '123',
        success: function() {
          console.log(`${R.textStyles.timer(0).fontFamily}  loaded successfully`)
          resolve()
        },
        failure: function() {
          console.warn(`${R.textStyles.timer(0).fontFamily} 字體加載失敗`);
          resolve()
        }
      })

    })

    return Promise.all([p1,p2,p3])
  }

  loadSounds(vos){
    const queue = new createjs.LoadQueue()
    queue.installPlugin(createjs.Sound)
    queue.setMaxConnections(40)
    Object.keys(R.sounds)
      .map(k => R.sounds[k])
      .map(({src, volume}) => {
        queue.loadFile({ id: src, src: Array.isArray(src) ? src[0]: src }, { loadNow: false })
      })

    vos
      .filter(vo => vo === "undefined")
      .map(vo => { return { id: vo, src: `static/vo/${vo}.mp3` } })
      .map(({id, src}) => {
        const volume = 1
        // dynamic inject
        R.vos[id] = {
          src: [src],
          volume: volume,
        }

        if(!GameUtils.isIE11()){
          // IE 11 can't load many file
          queue.loadFile({ id: src, src: Array.isArray(src) ? src[0]: src }, { loadNow: false })
        }
      })

    queue.on("fileload", () => {
      Events.hub.publishEvent(Events.LOADED_FILE, 1)
    })

    return new Promise((resolve, reject) => {
      queue.on("complete", () => {
        resolve()
      })

      queue.load()
    })
  }

  loadImages(){
    return new Promise((resolve, reject) => {
      const loader = PIXI.loader
      loader.reset()

      for(let key in R.images){
        if(R.images.hasOwnProperty(key)){
          const res = R.images[key]
          if(Array.isArray(res)){
            res.forEach((_) => {
              loader.add(_.name, _.src)
            })
          }
          else {
            loader.add(res.name, res.src)
          }
        }
      }

      for(let key in R.spriteSheets){
        if(R.spriteSheets.hasOwnProperty(key)){
          const res = R.spriteSheets[key]
          if(Array.isArray(res.json)){
            res.json.forEach((src, i) => {
              loader.add(`${res.id}-${i}`, src)
            })
          }
          else {
            loader.add(res.id, res.json)
          }
        }
      }

      for(let key in R.spines){
        if(R.spines.hasOwnProperty(key)){
          const res = R.spines[key]
          if(Array.isArray(res.json)){
            res.json.forEach((src, i) => {
              loader.add(`${res.id}-${i}`, src)
            })
          }
          else {
            loader.add(res.id, res.json)
          }
        }
      }

      loader.onProgress.add((a,b) => {
        Events.hub.publishEvent(Events.LOADED_FILE, 1)
      })

      loader.load((loader, resources) => {
        resolve(resources)
      })
    })

  }
}



// WEBPACK FOOTER //
// ./src/game/BaseGame.js